module.exports = "/_next/static/images/pit-093eb8dd0073b7bb3bb357a00ada00cd.svg";